module.exports = __webpack_public_path__ + "static/media/ECTA.e93e99a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/ECTA.jpg
// module id = 1325
// module chunks = 1